module.exports = __webpack_public_path__ + "static/media/LokiFrame83.8f1e5890.png";